import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRightLong } from "react-icons/fa6";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);

  const slides = [banner1, banner2, banner3, banner4];

  useEffect(() => setReady(true), []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) {
    return (
      <div style={{
        height: "calc(100vh - var(--topBarHeight))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <style>{`
        .hero-modern {
          position: relative;
          height: calc(100vh - var(--topBarHeight));
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          overflow: hidden;
          color: #fff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        /* Background */
        .hero-bg {
          position: absolute;
          inset: 0;
          z-index: 0;
        }

        .hero-bg img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.1);
          transition: opacity 1s ease, transform 6s ease;
        }

        /* Overlay */
        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(2,6,23,0.9),
            rgba(2,6,23,0.7),
            rgba(2,6,23,0.85)
          );
          z-index: 1;
        }

        /* Content */
        .hero-content {
          position: relative;
          z-index: 1;
          max-width: 800px;
          padding: 0 1.5rem;
        }

        .hero-title {
          font-size: 2.8rem;
          font-weight: 700;
          line-height: 1.15;
          margin-bottom: 2rem;
          letter-spacing: -0.02em;
        }

        @media (min-width: 768px) {
          .hero-title {
            font-size: 4rem;
          }
        }

        /* CTA */
        .hero-cta {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          padding: 0.9rem 1.6rem;
          border-radius: 999px;
          background: #2563eb;
          border: none;
          color: #fff;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .hero-cta:hover {
          background: #1d4ed8;
          transform: translateY(-2px);
        }
      `}</style>

      <section className="hero-modern">

        {/* Background */}
        <div className="hero-bg">
          <img src={slides[slideIndex]} alt="" />
        </div>

        {/* Overlay */}
        <div className="hero-overlay"></div>

        {/* Content */}
        <div className="hero-content">
          <h1 className="hero-title">
            Build {" "} <span className="text-primary font-bold">scalable ICT systems</span> that power modern organizations.
          </h1>

          <button
            className="hero-cta"
            onClick={() => appContext.navTo({ item: "services" })}
          >
            Explore Services
            <FaArrowRightLong />
          </button>
        </div>

      </section>
    </>
  );
}